export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("block-scroll-navigation", {
    mounted(el, binding) {
      if (!binding.value) return; // Only apply if directive value is true
    },
    unmounted(el) {},
  });
});
